import type { ComponentType } from 'react';
import { createBrowserRouter } from 'react-router';
import { RequerLoja, RequerSessao } from './Guardas';
import { LayoutPainel } from './LayoutPainel';
import { PaginaErro } from './PaginaErro';

// Cada tela é um chunk carregado sob demanda: o link público de rastreio não baixa o painel,
// e o painel não baixa o mapa.
const tela = (importar: () => Promise<{ default: ComponentType }>) => async () => ({
  Component: (await importar()).default,
});

export const roteador = createBrowserRouter([
  {
    errorElement: <PaginaErro />,
    children: [
      { index: true, lazy: tela(() => import('../features/inicio/PaginaInicial')) },
      { path: '/entrar', lazy: tela(() => import('../features/auth/PaginaEntrar')) },
      { path: '/nova-senha', lazy: tela(() => import('../features/auth/PaginaNovaSenha')) },
      {
        path: '/conta-confirmada',
        lazy: tela(() => import('../features/auth/PaginaContaConfirmada')),
      },
      // Pública (exigência da Google Play): explica como excluir a conta do app do entregador.
      {
        path: '/excluir-conta',
        lazy: tela(() => import('../features/auth/PaginaExcluirConta')),
      },
      // Pública (exigência da Google Play): Política de Privacidade dos apps e do painel.
      {
        path: '/privacidade',
        lazy: tela(() => import('../features/auth/PaginaPrivacidade')),
      },
      { path: '/r/:token', lazy: tela(() => import('../features/rastreio/PaginaRastreio')) },
      {
        element: <RequerSessao />,
        children: [
          { path: '/criar-loja', lazy: tela(() => import('../features/empresa/PaginaCriarLoja')) },
          {
            element: <RequerLoja />,
            children: [
              {
                path: '/pedidos/:id/imprimir',
                lazy: tela(() => import('../features/pedidos/PaginaImpressao')),
              },
              {
                element: <LayoutPainel />,
                children: [
                  {
                    path: '/pedidos',
                    lazy: tela(() => import('../features/pedidos/PaginaPedidos')),
                  },
                  {
                    path: '/pedidos/novo',
                    lazy: tela(() => import('../features/pedidos/PaginaNovoPedido')),
                  },
                  {
                    path: '/pedidos/:id',
                    lazy: tela(() => import('../features/pedidos/PaginaPedido')),
                  },
                  {
                    path: '/clientes',
                    lazy: tela(() => import('../features/clientes/PaginaClientes')),
                  },
                  {
                    path: '/clientes/:id',
                    lazy: tela(() => import('../features/clientes/PaginaCliente')),
                  },
                  {
                    path: '/entregadores',
                    lazy: tela(() => import('../features/entregadores/PaginaEntregadores')),
                  },
                  {
                    path: '/entregadores/:id',
                    lazy: tela(() => import('../features/entregadores/PaginaEntregador')),
                  },
                  {
                    path: '/configuracoes',
                    lazy: tela(() => import('../features/empresa/PaginaConfiguracoes')),
                  },
                  { path: '*', element: <PaginaErro /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);
